import React, { useState, useEffect } from 'react';

import HeroSection from './components/HeroSection';
import RecentWork from './components/RecentWork';
import PrecisionArtistry from './components/PrecisionArtistry';
import ClientCarousel from './components/ClientCarousel';
import PerformanceMetrics from './components/PerformanceMetrics';
import WhatsAppFloatingButton from '../../components/ui/WhatsAppFloatingButton'; 
import BookingCTA from './components/BookingCTA';
import ServiceCards from './components/ServicesHighlights';
import TechnicalExpertise from './components/TechnicalExpertise';

const HomepageCinematicGateway = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); 

    return () => clearInterval(timer);
  }, []);

  const getTimeBasedContent = () => {
    const hour = currentTime.getHours();
    
    if (hour >= 6 && hour < 12) {
      return {
        greeting: "Good Morning",
        theme: "dawn",
        videoSrc: "https://videos.pexels.com/video-files/3571264/3571264-uhd_2560_1440_30fps.mp4"
      };
    } else if (hour >= 12 && hour < 18) {
      return {
        greeting: "Good Afternoon", 
        theme: "daylight",
        videoSrc: "https://videos.pexels.com/video-files/3209828/3209828-uhd_2560_1440_25fps.mp4"
      };
    } else {
      return {
        greeting: "Good Evening",
        theme: "golden",
        videoSrc: "https://videos.pexels.com/video-files/3571077/3571077-uhd_2560_1440_30fps.mp4"
      };
    }
  };

  const timeContent = getTimeBasedContent();

  return (
    <div className="min-h-screen bg-background">
      {/* Hero Section */}
      <HeroSection  timeContent={timeContent} />
      <ServiceCards />
      
      {/* Recent Work Grid */}
      <RecentWork />
      
      {/* Precision Meets Artistry */}
      <PrecisionArtistry />
     <TechnicalExpertise />
      {/* Client Carousel */}
      <ClientCarousel />
      
      {/* Performance Metrics */}
      {/* <PerformanceMetrics /> */}
      
      {/* Booking CTA */}
      <BookingCTA />
      <WhatsAppFloatingButton />
    </div>
  );
};

export default HomepageCinematicGateway;